import ODateRangePicker from "components/shared/datePicker/ODateRangePicker";
import AuthContext from "context/AuthContext";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiPost } from "../../utils/apiFetch";
import pathObj from "../../utils/pathObj";

function WalletWindow() {
  const { t } = useTranslation();
  const { updatePageName, setLoading } = useContext(AuthContext);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [amountWindowPDFBase64, setAmountWindowPDFBase64] = useState("");
  const [amountWindowExcelBase64, setAmountWindowExcelBase64] = useState("");
  const [username, setUsername] = useState("");
  const [isReset, setIsReset] = useState(false);


  const getWalletWindow = async () => {
    try {
      setLoading(true);
      setAmountWindowExcelBase64("");
      setAmountWindowPDFBase64("");

      const res = await apiPost(pathObj.getWalletBalanceWindow, {
        username,
        fromDate: startDate,
        toDate: endDate,
      });

      setAmountWindowPDFBase64(res?.data?.results?.pdfBase64);
      setAmountWindowExcelBase64(res?.data?.results?.excelBase64);
    } catch (error) {
      console.log("error:", error);
    }
    setLoading(false);
  };

  const handleReset = () => {
    setStartDate("");
    setEndDate("");
    setIsReset(true);
    setAmountWindowPDFBase64("");
    setAmountWindowExcelBase64("");
    setUsername("");
  };


  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    setIsReset(false);
  };

  useEffect(() => {
    updatePageName(t("O_WALLET_WINDOW"));
  }, []);

  return (
    <div>
      <div className="bg-[#F9F9F9]">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] rounded-lg">
            {/* filter section */}
            <form className="border-b border-b-[#E3E3E3]  px-4 py-3 pt-5 flex flex-wrap justify-between">
              <div className="col-span-2 flex flex-wrap  items-center">
                <div className="flex items-center lg:pt-0 pt-3 flex-wrap ">
                  <ODateRangePicker handleDateChange={handleDateChange} isReset={isReset} setIsReset={setIsReset} />
                  <div style={{ height: "50px" }}>
                    <button
                      type="button"
                      onClick={handleReset}
                      className="bg-LightBlue text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2"
                    >
                      {t("O_RESET")}
                    </button>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center px-4">
                <label htmlFor="default-search" className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">
                  {t("O_SEARCH")}
                </label>
                <div className="flex">
                  <div className="relative ml-4">
                    <div>
                      <input
                        type="search"
                        id="default-search"
                        className="block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[250px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder={t("O_USERNAME")}
                        value={username}
                        title=""
                        required
                        onChange={(e) => setUsername(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="relative ml-4">
                    <div style={{ height: "50px" }}>
                      <button
                        type="button"
                        onClick={getWalletWindow}
                        className="bg-LightBlue text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2"
                      >
                        {t("O_SEARCH")}
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </form>
            <section className="table-section">
              {amountWindowPDFBase64 && amountWindowExcelBase64 ? (
                <>
                  <div className="w-100 flex items-end justify-end mt-4">
                    <a id="excelDownloadLink" href={"data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," + amountWindowExcelBase64} download={"pasqyre_gjendjeje.xlsx"}>
                      <button type="button" className="bg-LightBlue text-sm px-8 ml-3 py-2 mx-5 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2">
                        <div className="d-flex gap-2">
                          <span>Excel</span>
                        </div>
                      </button>
                    </a>
                  </div>
                  <div className="m-5 w-100 h-100">
                    <iframe src={"data:application/pdf;base64," + amountWindowPDFBase64} width="100%" height="800px" title="pasqyre_gjendje"></iframe>
                  </div>
                </>
              ) : null}
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WalletWindow;
